import(/* webpackMode: "eager" */ "/opt/build/repo/apps/kids-guitar-dojo/src/app/global-error.tsx");
